export default function createRef() {
    const ref = Object.assign((value) => ref.value = value, { value: null });
    return ref;
}



// WEBPACK FOOTER //
// ./src/assets/scripts/utils/createRef.ts